module.exports = __webpack_public_path__ + "img/39433A_65866E_86BF8B_BFF8D8-256px.3332f8c8.png";